const DEV_HOST_KEY = "jddq_dev_host";

// xiaobman和color的host映射
export const HOST_MAP: Record<string, string> = {
    // 预发
    "manyfx.jd.com": "beta-api.m.jd.com",
    // 预发2
    "manyfx2.jd.com": "beta-api2.m.jd.com",
    // 预发3
    "manyfx3.jd.com": "beta-api3.m.jd.com",
    // 灰度
    "manxrc.jd.com": "beta-api4.m.jd.com",
    // 线上
    "manx.jd.com": "api.m.jd.com",
};

// 各环境默认的host
const ENV_HOST: Record<string, string> = {
    development: "manyfx.jd.com",
    gray: "manxrc.jd.com",
    production: "manx.jd.com",
};

// 各环境默认的host
const JDDJ_ENV_HOST: Record<string, string> = {
    development: "pre-new-yunying.jddj.com",
    gray: "yunying-new.jddj.com",
    production: "yunying-new.jddj.com",
};

const REACT_APP_ENV = process.env.REACT_APP_ENV as string;

export const canSwitchHost = !["production", "gray"].includes(REACT_APP_ENV);

export const setHost = (host: string) => {
    if (host && Object.keys(HOST_MAP).includes(host)) {
        sessionStorage.setItem(DEV_HOST_KEY, host);
    } else {
        sessionStorage.removeItem(DEV_HOST_KEY);
    }
};

export const getHost = (): {
    xiaobBaseUrl: string;
    colorBaseUrl: string;
    yunyingBaseUrl: string;
} => {
    // 默认线上兜底
    let xiaobBaseUrl = ENV_HOST[REACT_APP_ENV] || ENV_HOST.prod;
    let colorBaseUrl = HOST_MAP[xiaobBaseUrl] || "api.m.jd.com";
    let yunyingBaseUrl = JDDJ_ENV_HOST[REACT_APP_ENV] || JDDJ_ENV_HOST.prod;

    const cacheHost = sessionStorage.getItem(DEV_HOST_KEY);

    // 有缓存，并且不是灰度和线上，走缓存
    if (cacheHost && canSwitchHost) {
        xiaobBaseUrl = cacheHost;
        colorBaseUrl = HOST_MAP[xiaobBaseUrl] || colorBaseUrl;
    }

    return {
        colorBaseUrl: `//${colorBaseUrl}`,
        xiaobBaseUrl: `//${xiaobBaseUrl}`,
        yunyingBaseUrl: `//${yunyingBaseUrl}`,
    };
};
